import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";

import LoggedInContainer from "web_modules/shared/LoggedInContainer";
import { loadSearchData as loadSearchDataAction } from "web_modules/redux/searchLoans/actions";
import { getSessionToken } from "web_modules/shared/session";

import AppEditor from "./AppEditor";
import Homepage from "./Homepage";
import HurdleEditor from "./HurdleEditor";
import NotesScreen from "./NotesScreen";
import Pipeline from "./Pipeline";
import Queues from "./Queues";

const navPaths = {
  root: "/underwriter",
  app: "/underwriter",
  queues: "/underwriter/queues",
  pipeline: "/reporting/pipeline", // NOTE: *not* an /underwriter path
  tools: "/tools", // NOTE: *not* an /underwriter path
};

const reduxActions = { loadSearchData: loadSearchDataAction };
type Props = typeof reduxActions;

const UnderwriterDashboard: React.FC<Props> = props => {
  const { loadSearchData } = props;

  useEffect(() => {
    getSessionToken() && loadSearchData();
  }, []);

  return (
    <LoggedInContainer
      titleLink={{
        name: "Underwriter",
        to: navPaths.root,
      }}
      headerLinks={[
        {
          name: "Loans",
          to: navPaths.root,
          pathIsCurrentPage: (path: string) =>
            !path.startsWith(navPaths.queues) && // remove when queues is no longer also an /underwriter path
            (path === navPaths.root ||
              path === `${navPaths.root}/` ||
              path.startsWith(navPaths.app)),
        },
        {
          name: "Queues",
          to: navPaths.queues,
        },
        {
          name: "Pipeline",
          to: navPaths.pipeline,
        },
        {
          name: "Tools",
          to: navPaths.tools,
        },
      ]}
    >
      <Switch>
        <Route exact path="/underwriter/app/:appId/notes" component={NotesScreen} />
        <Route
          exact
          path="/underwriter/app/:appId/:tabGroupName/:tabLink"
          component={HurdleEditor}
        />
        <Route exact path="/underwriter/app/:appId/:hurdleType" component={HurdleEditor} />
        <Route exact path="/underwriter/app/:appId" component={AppEditor} />
        <Route exact path="/underwriter/queues" component={Queues} />
        <Route exact path="/underwriter" component={Homepage} />
        <Route exact path="/underwriter/pipeline" component={Pipeline} />
      </Switch>
    </LoggedInContainer>
  );
};

export default connect(null, reduxActions)(UnderwriterDashboard);
